// Lib
import Tracking from 'lib/tracking';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';
import formatMoney from 'utils/format-money';

export default component((node) => {
  const { originalPriceLabel, priceLabel, remove, input } = choozy(node);
  const { id, price, originalPrice, suitParentColor, suitParentTitle, handle } = node.dataset;

  const emitCartChangeEvent = (quantity, oldQuantity) => {
    const detail = {
      id,
      quantity,
      oldQuantity,
    };

    // Only add suit parent properties if they exist
    if (suitParentColor) {
      detail.suitParentColor = suitParentColor;
    }

    if (suitParentTitle) {
      detail.suitParentTitle = suitParentTitle;
    }

    const event = new CustomEvent('cart:change', {
      bubbles: true,
      cancelable: true,
      detail,
    });

    node.dispatchEvent(event);
  };

  node.addEventListener('quantity:change', (e) => {
    e.stopPropagation();

    priceLabel.textContent = formatMoney(e.detail.value * parseInt(price, 10) * 100);
    originalPriceLabel.textContent =
      originalPrice > price ? formatMoney(e.detail.value * parseInt(originalPrice, 10) * 100) : '';

    emitCartChangeEvent(e.detail.value, e.detail.oldValue);
  });

  remove.addEventListener('click', () => {
    emitCartChangeEvent(0, input.value);
  });

  node.addEventListener('click', (event) => Tracking.selectItemCallback(event, false, true));
});
